import { call, put } from 'redux-saga/effects';

import { getUserProfile } from '../../services/user';
import { requestUserProfileError, requestUserProfileSuccess } from './actions';
import { AuthActionTypes } from '../auth/types';

export function* fetchProfileUser(): any {
  const payloadUserProfile = yield call(getUserProfile);
  if (payloadUserProfile.success) {
    yield put(requestUserProfileSuccess(payloadUserProfile.data));
  } else {
    yield put({ type: AuthActionTypes.USER_LOGOUT });
    yield put(requestUserProfileError(payloadUserProfile));
  }
}

export const userProfile = () => {
  const roleUser = window.localStorage.getItem('role');
  return roleUser;
};
